import React from "react";

export default function MyIcon({
  Icon,
  width = 30,
  height = width,
  className = "",
}) {
  return (
    <span
      className={`bg-icon rounded-circle d-inline-block position-relative ${className}`}
      style={{
        width: width * 1,
        height: height * 1,
      }}
    >
      <Icon width={width} height={height} className="position-absolute top-50 start-50 translate-middle"/>
    </span>
  );
}
